<template>
  <form class="a-filter admin-filter" action="">
    <div class="a-filter__header">
      <h2 v-t="'admin.accreditations'"></h2>
    </div>
    <div class="a-filter__block ">
      <div class="a-filter__label ">{{$t('form.accreditation-search.request-type.label')}}:</div>
      <div class="a-filter__block-checkbox a-checkbox">
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="filters.types.digitalSignature">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text" v-t="'form.accreditation-search.request-type.signature'"></span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="filters.types.accreditation">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text" v-t="'form.accreditation-search.request-type.accreditation'"></span>
        </label>
      </div>
    </div>
    <div class="a-filter__block ">
      <div class="a-filter__label ">{{$t('form.accreditation-search.status.label')}}:</div>
      <div class="a-filter__block-checkbox a-checkbox">
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="filters.states.draft">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text" v-t="'form.accreditation-search.status.draft'"></span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="filters.states.processing">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text" v-t="'form.accreditation-search.status.processing'"></span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="filters.states.notActive">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text" v-t="'form.accreditation-search.status.not-active'"></span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="filters.states.approved">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text" v-t="'form.accreditation-search.status.approved'"></span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="filters.states.declined">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text" v-t="'form.accreditation-search.status.declined'"></span>
        </label>
      </div>
    </div>
    <div class="a-container-form ">
      <div class="a-label a-label--w-215" v-t="'form.accreditation-search.organization.label'"></div>
      <organization-search class="select-w-570"
                           multiple
                           tags
                           :placeholder="$t('form.accreditation-search.organization.placeholder')"
                           v-model="filters.organizations">
      </organization-search>
    </div>
    <div class="a-container-form ">
      <div class="a-label a-label--w-215" v-t="'form.accreditation-search.user.label'"></div>
      <user-search class="select-w-570"
                   all-users-search
                   multiple
                   tags
                   :placeholder="$t('form.accreditation-search.user.placeholder')"
                   v-model="filters.users">
      </user-search>
    </div>
    <div class="a-filter__footer ">
      <button class="gui-btn gui-btn--white-border gui-btn--w-167" type="button" @click="resetFilters" v-t="'buttons.reset-filters'"></button>
      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="fetchAccreditations" v-t="'buttons.apply'"></button>
    </div>
  </form>
</template>

<script>
  import OrganizationSearch from '@/components/common/inputs/OrganizationSearch'
  import UserSearch from '@/components/common/inputs/UserSearch'

  export default {
    components: {
      OrganizationSearch,
      UserSearch
    },

    data: () => ({
      filters: {
        types: {
          digitalSignature: undefined,
          accreditation: true
        },
        states: {
          draft: undefined,
          processing: true,
          notActive: undefined,
          approved: undefined,
          declined: undefined
        },
        organizations: [],
        users: []
      }
    }),

    created() {
      this.fetchAccreditations();
    },

    methods: {
      async fetchAccreditations() {
        this.runBlockerAction(async () => {
          try {
              await this.$store.dispatch('fetchAccreditations', {
                showDigitalSignatures: this.filters.types.digitalSignature,
                showAccreditations: this.filters.types.accreditation,
                showInDraft: this.filters.states.draft,
                showInProcessing: this.filters.states.processing,
                showInNotActive: this.filters.states.notActive,
                showInApproved: this.filters.states.approved,
                showInDeclined: this.filters.states.declined,
                organizations: (this.filters.organizations || []).map(e => e.id),
                users: (this.filters.users || []).map(e => e.id)
              })
          }
          catch(e) {
            console.error('unable to fetch list of accreditations', e);
            this.globalErrorHandler(e);
          }
        });
      },

      resetFilters() {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    }
  }
</script>

<style scoped>

</style>
